module.exports = __webpack_public_path__ + "img/summary_2.fa6551b6.png";